import React from 'react'
import styles from './Benefits.module.scss';
import { Title } from '../../components';
import Registrate from '../../assets/img-registrate.png';
import Control from '../../assets/img-control.png';
import Pagos from '../../assets/img-pagos.png';
import Soporte from '../../assets/img-soporte.png';
import Conecta from '../../assets/img-conecta.png';



export const Benefits = ({ref}: any) => {
    return (
        <div ref={ref} className={styles.contentBenefits}>
            <p className={`${styles.titleBenefits} title-montserrat text-black text-left`}>Beneficios</p>
            <div className={styles.contentCards}>
                <div className={styles.cards}>
                    <Title title="Regístrate en minutos" />
                    <p className='subtext-inter text-black'>
                        Registrarse es muy fácil, descarga nuestra aplicación desde <span className='text-bold'>Google Play</span> o <span className='text-bold'>App Store.</span>
                    </p>
                    <img alt='registrate' src={Registrate} />
                </div>
                <div className={styles.cards}>
                    <Title title="Control" />
                    <p className='subtext-inter text-black'>
                        Seguro y completamente transparente. Cada transacción se refleja
                        de inmediato, lo que te permite tener un control total de tu dinero en
                        tiempo real.
                    </p>
                    <img alt='control' src={Control} />
                </div>
            </div>
            <div className={styles.cardBlack}>
                <div className={styles.contentText}>
                    <Title title="Pagos sin límites" color="white" />
                    <p className='subtext-inter text-white'>
                        Gestiona tus <span className='text-bold'>compromisos financieros</span> con total <span className='text-bold'>confianza</span>, mantén el control de tus operaciones y haz que tu negocio avance sin límites.
                    </p>
                    <p className='subtext-inter text-white'>
                        Con nuestra tarjeta <span className='text-bold'>Livingrock</span>, puedes realizar pagos dentro de México como en el extranjero.
                    </p>
                </div>
                <div className={styles.contentImg}>
                    <img alt='pagos' src={Pagos} />
                </div>
            </div>
            <div className={styles.contentCards}>
                <div className={styles.cards}>
                    <Title title="Conecta tus tarjetas" />
                    <p className='subtext-inter text-black'>
                        Nuestra aplicación <span className='text-bold'>LivingRock</span> te permite asociar tarjetas <span className='text-bold'>facilmente</span>
                        a las cuentas de tus clientes y colaboradores, avaladas por <span className='text-bold'>MasterCard</span> y aceptadas en todos los comercios.
                    </p>
                    <img className={styles.imgRounded} alt='conecta' src={Conecta} />
                </div>
                <div className={styles.cards}>
                    <Title title="Soporte" />
                    <p className='subtext-inter text-black'>
                        Nuestro equipo está disponible para acompañarte en cada etapa del
                        proceso, resolviendo dudas y brindando soporte técnico 24/7
                    </p>
                    <img className={styles.imgRounded} alt='soporte' src={Soporte} />
                </div>
            </div>
        </div>
    )
}
